var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-register"}},[(_vm.loading)?_c('Loading'):_c('Register',{attrs:{"customItems":_vm.customItemsRegister}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }